/* CorniceWert: keep floating WhatsApp support clear of the cart checkout button. */
(() => {
  const drawerSelector = 'cart-drawer .drawer.active, cart-drawer[open], cart-drawer.active';
  const updateCartState = () => {
    const open = !!document.querySelector(drawerSelector);
    document.body.classList.toggle('cw-cart-drawer-open', open);
  };
  updateCartState();
  const observer = new MutationObserver(updateCartState);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'aria-hidden']
  });
  document.addEventListener('shopify:section:load', updateCartState);
  document.addEventListener('click', () => requestAnimationFrame(updateCartState), true);
})();
